
import { defineComponent } from 'vue';
import PrzItem from '../AbstractItem/Component.vue';
import PrzElementContent from '../Parts/ContentElement/Component.vue';
import PrzActionBox from '../Parts/ActionBox/Component.vue';
import PrzTimer from '../Parts/ContentTimer/Component.vue';
import PrzStarRating from '../Parts/StarRating/Component.vue';
import { BlockItem } from '@/models/Blocks/Itens/block-item';
import { BlockContent } from '@/models/Blocks/Itens/block-content';
import { BlockItemContent } from '@/models/Blocks/Itens/Types/block-content-types';
import { BlockEvents } from '@/models/Blocks/block-events';
export default defineComponent({
    components:{
        PrzItem,
        PrzElementContent,
        PrzActionBox,
        PrzTimer,
        PrzStarRating,
        Newsletter: () => import('@/components/Newsletter/Newsletter.vue')
    },
    props:{
        item:{
            type: BlockItem,
        }
    },
    data(){
        return {
            showNewsletter: false
        }
    },
    computed:{
        content(): BlockContent|null{
            return this.item instanceof BlockContent ? <BlockContent>this.item : null;
        },
        timerTitle():BlockItemContent|undefined{
            if(!this.content || !this.content.timer){
                return undefined;
            }
            return {text: this.content.timer.text, color: this.content.timer.textColor};
        },
        classNames(){
            let result = {'prz-blk-content-with-icon': this.content?.icon, 'prz-blk-content-with-img': this.content?.images};
            
            //Class defined in object
            let cssClass = this.content?.cssClass??'';
            if(cssClass){
                let list = cssClass.split(' ');
                list.forEach( (c) => {
                    result = {...result, [c] : true};
                });
            }
            return result;
        },
        hrefLabel(){
            const text = this.content?.title?.text ?? null;
            return text ? BlockItem.strippedContent(text) : null;
        }
    },
    methods: {
        actionClick(){
            const action = this.content?.action ?? undefined;
            if(action && action.value){
                const val = action.value;
                if(val.name == 'goToNotifications'){
                    window.location.href = val.url;
                    return;
                }
                if(val.name == 'openNewsletter' && !val.urlMobile){
                    this.showNewsletter = true;
                    return;
                }
                if(val.name == 'openNewsletter' && val.urlMobile){
                    window.location.href = val.urlMobile;
                    return;
                }
            }
            if(action){
                BlockEvents.AddActionBoxClick(this.$el, action);
            }
        },
        closeModal(){
            this.showNewsletter = false;
        }
    }
});
